module.exports = __webpack_public_path__ + "img/Whanau_Wellbeing.35b31c34.png";